import { ApolloProvider } from '@apollo/client';
import { useRecoilValue } from 'recoil';
import { organizationAtom } from 'services/organization/atom';
import React, { useMemo } from 'react';
import { createApolloClientForProvider } from 'core/services/apollo/createApolloClient';

export const ApolloClientProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  // NOTE: This is needed in order to update Apollo Client changes
  const organization = useRecoilValue(organizationAtom);

  const client = useMemo(() => {
    return createApolloClientForProvider(organization?.id || '');
  }, [organization?.id]);

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
